/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import WindowWatcher = alm.browser.WindowWatcher;
	import WindowWatcherEvent = alm.browser.WindowWatcherEvent;
	import DeviceInfo = alm.browser.DeviceInfo;
	import Logger = alm.debug.Logger;
	import AnimationFrameTicker = alm.time.AnimationFrameTicker;
	import AnimationFrameTickerEvent = alm.time.AnimationFrameTickerEvent;
	import Cmd = alm.util.Cmd;
	import Sequencer = gpx_visualizer_phase2.Sequencer;
	import Num = alm.util.Num;

	export class Application {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		private initialize():void {
			Logger.setLevelByQuery('log');
			Config.initialize();
			Sentry.getInstance().initialize();

			{
				const html = jQuery('html');

				// apply mode
				html.addClass(Config.mode);

				// apply environment
				html.addClass(Config.environment);
			}

			this.loading = new Loading();
			this.loading.ready();
			this.loading.show();

			this.errorDialog = new ErrorDialog();
			this.errorDialog.ready();

			if (!Device.isWebGlAvailable()) {
				Sentry.getInstance().send(Config.sentryMessageNoWebGl, SentryLevel.Info);
				ErrorDialog.show(Config.errorNoWebGl, -1);
				return;
			}

			this.audioPlayer = AudioPlayer.getInstance();
			this.audioPlayer.load(AudioId.lo, 0.3);
			this.audioPlayer.load(AudioId.hi, 0.3);
			this.audioPlayer.load(AudioId.slider, DeviceInfo.getIsDesktop() ? 0.3 : 0.2);

			this.map = new Map();
			this.threeManager = ThreeManager.getInstance();
			this.threeManager.setMap(this.map);

			this.information = Information.getInstance();

			this.controller = new Controller();
			this.controller.addEventListener(ControllerTerrainTypeEvent.CHANGE, this.controllerTerrainTypeChangeHandler);
			this.controller.addEventListener(ControllerLocationEvent.CURRENT, this.controllerLocationCurrentHandler);
			this.controller.addEventListener(ControllerSpeedEvent.CHANGE, this.controllerSpeedChangeHandler);
			this.controller.addEventListener(ControllerPlayPauseEvent.CHANGE, this.controllerPlayPauseChangeHandler);
			this.controller.addEventListener(ControllerSeekBarEvent.SEEK, this.controllerSeekBarSeekHandler);
			this.controller.addEventListener(ControllerSeekBarEvent.DRAG_START, this.controllerSeekBarDragStartHandler);
			this.controller.addEventListener(ControllerSeekBarEvent.DRAG_END, this.controllerSeekBarDragEndHandler);

			this.progressManager = ProgressManager.getInstance();
			this.progressManager.addEventListener(ProgressManagerSeekEvent.SEEK, this.progressManagerSeekHandler);
			this.progressManager.addEventListener(ProgressManagerProgressEvent.PROGRESS, this.progressManagerProgressHandler);
			this.progressManager.addEventListener(ProgressManagerProgressEvent.START, this.progressManagerStartHandler);
			this.progressManager.addEventListener(ProgressManagerProgressEvent.COMPLETE, this.progressManagerCompleteHandler);

			//this.stats = new Stats();
			//this.stats.showPanel(0);

			// start
			WindowWatcher.addEventListener(WindowWatcherEvent.RESIZE, this.windowWatcherResizeHandler);
			WindowWatcher.start();

			this.ticker = new AnimationFrameTicker();
			this.ticker.addEventListener(AnimationFrameTickerEvent.TICK, this.tickerTickHandler);
			this.ticker.start();

			this.assetLoader = AssetLoader.getInstance();
			this.assetLoader.addEventListener(AssetLoaderEvent.COMPLETE, this.assetLoaderCompleteHandler);
			this.assetLoader.load();
		}

		private assetLoaderCompleteHandler = (event:AssetLoaderEvent):void => {
			this.loading.hide();

			DateUtil.setActivityTimeZone(this.assetLoader.getActivity().getTimeZone());
			this.track = this.assetLoader.getTrack();

			this.map.ready();
			this.controller.ready();
			this.information.ready();

			// setup progress manager
			if (Config.useProgressByDistance) {
				this.progressManager.setRange(0, this.track.getLength());
			} else {
				this.progressManager.setRange(this.track.getFromDateTime(), this.track.getToDateTime());
			}
			this.setProgressSpeed(Config.progressDurationDefaultIndex);
			this.applyProgress(0);

			this.threeManager.getScene().add(this.map.getView());
			this.threeManager.setSun(Math.PI, Num.degToRad(50), 0.8);
			this.threeManager.reset(this.map.getCurrentTrackPosition());
			this.threeManager.setInteraction(false);

			// start
			this.start();
		};

		private start():void {
			jQuery('#overlay').css('display', 'block');

			//if (Config.mode == Mode.Recording) {
				// recording mode
				this.startOpening();

			//} else {
			//	// interactive mode
			//	this.map.show();
			//	this.information.show();
			//	this.controller.show();

			//	this.progressManager.play();
			//	this.wasProgressManagerPlaying = this.progressManager.getIsPlaying();
			//	this.map.showEdge();

			//	this.threeManager.startOpening();
			//}
		}

		private startOpening():void {
			jQuery('#sequence').css('display', 'block');

			this.opening = new Opening();
			this.opening.ready();

			this.ending = new Ending();
			this.ending.ready();

			this.sequence = new cmd.Serial(
				new cmd.Parallel(
					this.opening.getShowCommand(),
					this.map.getShowCommand(),
				),
				new cmd.Func(():void => {
					if (Config.mode == Mode.Recording) {
						trace('[Sequence] recording status : start');
						UrlUtil.replaceRecordingStatus('start');
					}
				}),
				new cmd.Wait(2000),
				new cmd.Func(():void => {
					this.threeManager.startOpening();
				}),
				new cmd.Wait(500),
				this.opening.getHideCommand(),
				new cmd.Wait(1000),
				new cmd.Func(():void => {
					this.progressManager.play();
					this.wasProgressManagerPlaying = this.progressManager.getIsPlaying();
					this.map.showEdge();
				}),
				new cmd.Wait(500),
				new cmd.Func(():void => {
					this.information.show();
					if (Config.mode == Mode.Interactive) {
						this.controller.show();
						this.threeManager.setInteraction(true);
					}
				}),
			);
			this.sequence.execute();
		}

		private startEnding():void {
			Cmd.stop(this.sequence);
			this.sequence = new cmd.Serial(
				new cmd.Func(():void => {
					this.threeManager.startEnding(this.map.getMapCenter());
					this.map.hideEdge();
				}),
				new cmd.Wait(200),
				new cmd.Func(():void => {
					this.information.hide();
				}),
				new cmd.Wait(3500),
				this.ending.getShowCommand(),
				new cmd.Wait(2000),
				new cmd.Func(():void => {
					trace('[Sequence] recording status : complete');
					UrlUtil.replaceRecordingStatus('goal');
				}),
			);
			this.sequence.execute();
		}





		private update():void {
			//this.stats.begin();

			if (this.map.getIsShown()) {
				this.progressManager.update();
				this.map.update();

				// tracking
				if (!this.threeManager.getIsEnding()) {
					this.threeManager.setLookAtTarget(this.map.getCurrentTrackPosition());
				}
				this.threeManager.update();
			}

			//this.stats.end();
		}

		private resize():void {
			this.threeManager.resize();
		}





		private applyProgress(ratio:number):void {
			if (Config.useProgressByDistance) {
				// route
				const point = this.track.leapNearestPointsByDistanceRatio(ratio);
				this.map.setHeadPosition(point);

				// information
				this.information.setCurrentDate(point.getDateTime());
				this.information.setElapsedTime(point.getElapsedTime());

			} else {
				// route
				const point = this.track.leapNearestPointsByElapsedTimeRatio(ratio);
				this.map.setHeadPosition(point);

				// information
				this.information.setCurrentDate(this.progressManager.getCurrent());
				this.information.setElapsedTime(this.progressManager.getElapsed());
			}
		}

		private setProgressSpeed(state:number):void {
			if (state == -1) return;
			const duration = Config.progressDurations[state];
			trace('[Application] duration :', duration, 'sec');

			let speed:number;
			if (Config.useProgressByDistance) {
				speed = this.track.getLength() / (duration * 1000);
			} else {
				speed = this.track.getDuration() / (duration * 1000);
			}

			this.progressManager.setSpeed(speed);
			this.controller.setSpeedState(state);

			// update url
			UrlUtil.replaceSpeed((state + 1).toString());
		}

		private progressManagerSeekHandler = (event:ProgressManagerSeekEvent):void => {
			this.applyProgress(event.getRatio());
		};

		private progressManagerProgressHandler = (event:ProgressManagerProgressEvent):void => {
			this.applyProgress(event.getRatio());
		};

		private progressManagerStartHandler = (event:ProgressManagerProgressEvent):void => {
		};

		private progressManagerCompleteHandler = (event:ProgressManagerProgressEvent):void => {
			if (Config.mode == Mode.Recording) {
				this.startEnding();
			}
		};





		private tickerTickHandler = (event:AnimationFrameTickerEvent):void => {
			this.update();
		};

		private windowWatcherResizeHandler = (event:WindowWatcherEvent):void => {
			this.resize();
		};





		private controllerTerrainTypeChangeHandler = (event:ControllerTerrainTypeEvent):void => {
			this.map.setNextTerrainType();
		};

		private controllerLocationCurrentHandler = (event:ControllerLocationEvent):void => {
			if (!this.threeManager.getIsTracking()) {
				this.threeManager.startTracking(this.map.getCurrentTrackObject());
			}
		};

		private controllerSpeedChangeHandler = (event:ControllerSpeedEvent):void => {
			this.setProgressSpeed(event.getRequiredState());
		};

		private controllerPlayPauseChangeHandler = (event:ControllerPlayPauseEvent):void => {
			if (event.getIsPlayingRequired() && this.progressManager.getIsFinished()) {
				this.progressManager.reset();
				this.progressManager.play();
			} else {
				this.progressManager.toggle();
			}
		};

		private controllerSeekBarSeekHandler = (event:ControllerSeekBarEvent):void => {
			this.progressManager.seekByRatio(event.getRatio());
		};

		private controllerSeekBarDragStartHandler = (event:ControllerSeekBarEvent):void => {
			this.wasProgressManagerPlaying = this.progressManager.getIsPlaying();
			this.progressManager.stop();

			if (!this.threeManager.getIsTracking()) {
				this.threeManager.startTracking(this.map.getCurrentTrackObject());
			}
		};

		private controllerSeekBarDragEndHandler = (event:ControllerSeekBarEvent):void => {
			if (this.wasProgressManagerPlaying) {
				this.progressManager.play();
			}
		};





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private loading:Loading;
		private errorDialog:ErrorDialog;
		private map:Map;
		private track:Track;

		private assetLoader:AssetLoader;
		private progressManager:ProgressManager;
		private threeManager:ThreeManager;
		private information:Information;
		private controller:Controller;
		private audioPlayer:AudioPlayer;
		private ticker:AnimationFrameTicker;
		private sequencer:Sequencer;

		private sequence:cmd.Serial;
		private opening:Opening;
		private ending:Ending;


			//private stats:Stats;

		private wasProgressManagerPlaying:boolean;
	}
}
